/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Back_DataInputs */

const fr_welcome_back_data = /** @type {(inputs: Welcome_Back_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concernant les données, celles-ci ont été synchronisées afin qu'aucune information ne soit perdue.`)
};

const en_welcome_back_data = /** @type {(inputs: Welcome_Back_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regarding data, everything has been synchronized so that no information is lost.`)
};

/**
* | output |
* | --- |
* | "Regarding data, everything has been synchronized so that no information is lost." |
*
* @param {Welcome_Back_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const welcome_back_data = /** @type {((inputs?: Welcome_Back_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome_back_data(inputs)
	return en_welcome_back_data(inputs)
});